
// run callback when an element is scrolled into view

export default function loadOnScroll(el, callback, intPixelThreshold = 0) {
	if (!window.IntersectionObserver) return callback(el)
	const observer = new IntersectionObserver(handleIntersection, {
		rootMargin: `${intPixelThreshold}px 0px`,
		threshold: 0.01
	})
	observer.observe(el)
	function handleIntersection(entries, observer) {
		if (entries[0] && entries[0].intersectionRatio > 0) {
			observer.unobserve(el)
			callback(el)
		}
	}
}